// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.TwitterTweetCard_scroll__ZSyL9::-webkit-scrollbar {
  height: 8px;
}
.TwitterTweetCard_scroll__ZSyL9::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.TwitterTweetCard_scroll__ZSyL9::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.TwitterTweetCard_TwitterTweetCard__e\\+Dwr {
  font-family: chirp;
  height: 100%;
  margin-bottom: 20px;
  flex-direction: column;
  background-color: var(--bgColor);
  position: relative;
  width: 100%;
  color: var(--mainColor);
}
.TwitterTweetCard_TwitterTweetCard_Container__yXLfo {
  border-radius: 3px;
  border: 1px solid var(--borderColor);
}
.TwitterTweetCard_TwitterTweetCard_Container_content__mTqY5 {
  padding: 10px 10px 0;
}
.TwitterTweetCard_TwitterTweetCard_ImageGrid__xiwMs {
  width: 100%;
  display: grid;
  grid-gap: 3px;
  gap: 3px;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 5px;
  border-radius: 16px;
  overflow: hidden;
}
.TwitterTweetCard_TwitterTweetCard_ImageGrid__xiwMs img {
  display: block;
  min-height: 150px;
  max-height: 300px;
  height: 100%;
  max-width: 100% !important;
  border-radius: 0 !important;
  border-radius: initial !important;
}
.TwitterTweetCard_TwitterTweetCard_ImageGrid_three_items__hROmO img:first-of-type {
  grid-row: span 2/span 2;
  max-height: 100%;
}
.TwitterTweetCard_TwitterTweetCard_ImageGrid_fullWidthImg__y6f-G {
  grid-template-columns: repeat(1, 1fr) !important;
  max-height: 100%;
  width: 100%;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr.TwitterTweetCard_TweetRow__fJCr0 {
  min-height: auto;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_TwitterIconsBar__9mAW\\+ {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid var(--borderColor);
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_TwitterIconsBar_report__hKN4K {
  padding-bottom: 55px;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_TwitterIconsBar__9mAW\\+ div {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_topicTweetCard__QXPA1 .TwitterTweetCard_tweetImageUrl__FNfE- {
  max-width: 350px;
}
@media (min-width: 992px) and (max-width: 1200px) {
  .TwitterTweetCard_TwitterTweetCard__e\\+Dwr {
    padding: 0;
    border: 0;
  }
}
@media (max-width: 992px) {
  .TwitterTweetCard_TwitterTweetCard__e\\+Dwr {
    -webkit-padding-end: 20px;
            padding-inline-end: 20px;
  }
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr a:hover {
  color: var(--mainColor) !important;
  text-decoration: underline !important;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr:last-child {
  margin-bottom: 0;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_sectionSeparator__mYEJX {
  /*     span {
        text-transform: capitalize;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--tweetSubTitleColor);
      } */
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_sectionSeparator__mYEJX .TwitterTweetCard_conversations__YEz5- {
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: center;
}
.TwitterTweetCard_TwitterTweetCard__e\\+Dwr .TwitterTweetCard_sectionSeparator__mYEJX .TwitterTweetCard_conversations__YEz5- p {
  font-size: 10px;
  color: var(--borderColor);
}

.tweetBox .TwitterTweetCard_TweetBox__0dn3- {
  width: 100%;
}

.TwitterTweetCard_socialIcon__rZkf5,
.TwitterTweetCard_tweetSocialIcon__nollD {
  display: flex;
  align-items: center;
  width: -webkit-max-content;
  width: max-content;
}

.TwitterTweetCard_socialIcon__rZkf5,
.TwitterTweetCard_tweetSocialIcon__nollD,
.TwitterTweetCard_imgText__GM3OD a {
  display: flex;
  align-items: center;
  width: 100%;
}

.TwitterTweetCard_infoImg__FmaY5 section div:first-of-type {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  width: 35px !important;
  height: 35px !important;
}
.TwitterTweetCard_infoImg__FmaY5 section div:first-of-type.TwitterTweetCard_userImg__MnkWi {
  border-radius: 100%;
  overflow: hidden;
}
.TwitterTweetCard_infoImg__FmaY5 section div:first-of-type.TwitterTweetCard_userImg__MnkWi img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.TwitterTweetCard_topicTweets__0I2Sg {
  display: flex;
  align-items: flex-start !important;
  padding: 0 10px;
}

.TwitterTweetCard_tweetSection__2Ld-l {
  justify-content: space-between;
  font-size: 10px;
  width: 100%;
}
@media (min-width: 992px) and (max-width: 1200px) {
  .TwitterTweetCard_tweetSection__2Ld-l {
    justify-content: flex-start;
    gap: 10px;
  }
}

.TwitterTweetCard_spaceBetween__ut6L9 {
  justify-content: space-between;
}

.TwitterTweetCard_engRate__xMyAC {
  padding-bottom: 10px;
  margin-bottom: 10px !important;
  font-size: 10px;
}

.TwitterTweetCard_engText__3Q9-g {
  font-weight: 700;
}

.TwitterTweetCard_iconText__c07zz svg,
.TwitterTweetCard_iconText__c07zz img {
  -webkit-margin-end: 5px;
          margin-inline-end: 5px;
}

.TwitterTweetCard_flagImg__YRo4h {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  width: 15px;
  height: 10px;
}

.TwitterTweetCard_platformSection__d9CDs .TwitterTweetCard_platformName__HSDur {
  text-transform: capitalize;
}

.TwitterTweetCard_tweetDesc__ViewH p {
  font-size: 12px;
  margin-bottom: 13px;
  max-width: 100%;
}

.TwitterTweetCard_tweetSocialIcon__nollD {
  justify-content: space-between;
}

.TwitterTweetCard_tweetSocialIcon__nollD.TwitterTweetCard_newStyle__EEGZg {
  width: 380px;
}

.TwitterTweetCard_tweetVideo__v6vkL {
  position: relative;
  height: 130px;
  width: 130px;
}

.TwitterTweetCard_tweetImageUrl__FNfE- {
  position: relative;
  width: 100%;
  text-align: center;
}
.TwitterTweetCard_tweetImageUrl__FNfE- .TwitterTweetCard_VideoBtn__k6KHp {
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--bgColor);
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondaryColor);
}
.TwitterTweetCard_retweet__s674t {
  color: var(--mainColor);
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 7px;
}
.TwitterTweetCard_retweet__s674t svg {
  width: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/TwitterTweetCard/TwitterTweetCard.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AApDA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAuDF;AArDE;EACE,kBAAA;EACA,oCAAA;AAuDJ;AAtDI;EACE,oBAAA;AAwDN;AApDE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EAAA,QAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAsDJ;AArDI;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EAAA,iCAAA;AAuDN;AAnDM;EACE,uBAAA;EACA,gBAAA;AAqDR;AAlDI;EACE,gDAAA;EACA,gBAAA;EACA,WAAA;AAoDN;AA9CE;EACE,gBAAA;AAgDJ;AA9CE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;AAgDJ;AA/CI;EACE,oBAAA;AAiDN;AA/CI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiDN;AA1CI;EACE,gBAAA;AA4CN;AD2CE;EChKF;IA6EI,UAAA;IACA,SAAA;EA4CF;AACF;AD+BE;EC1JF;IAiFI,yBAAA;YAAA,wBAAA;EA8CF;AACF;AA5CI;EACE,kCAAA;EACA,qCAAA;AA8CN;AA3CE;EACE,gBAAA;AA6CJ;AA1CE;EACF;;;;;;SAAA;AAkDA;AA3CI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AA6CN;AA5CM;EACE,eAAA;EACA,yBAAA;AA8CR;;AAvCE;EACE,WAAA;AA0CJ;;AApCA;;EAEE,aAAA;EACA,mBAAA;EACA,0BAAA;EAAA,kBAAA;AAuCF;;AArCA;;;EAGE,aAAA;EACA,mBAAA;EACA,WAAA;AAwCF;;AArCE;EACE,wBAAA;UAAA,uBAAA;EACA,sBAAA;EACA,uBAAA;AAwCJ;AAvCI;EACE,mBAAA;EACA,gBAAA;AAyCN;AAxCM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA0CR;;AAnCA;EACE,aAAA;EACA,kCAAA;EACA,eAAA;AAsCF;;AApCA;EACE,8BAAA;EACA,eAAA;EACA,WAAA;AAuCF;ADxCE;ECFF;IAKI,2BAAA;IACA,SAAA;EAyCF;AACF;;AAtCA;EACE,8BAAA;AAyCF;;AAtCA;EACE,oBAAA;EACA,8BAAA;EACA,eAAA;AAyCF;;AAtCA;EACE,gBAAA;AAyCF;;AAtCA;;EAEE,uBAAA;UAAA,sBAAA;AAyCF;;AAtCA;EACE,wBAAA;UAAA,uBAAA;EACA,WAAA;EACA,YAAA;AAyCF;;AArCE;EACE,0BAAA;AAwCJ;;AAnCE;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AAsCJ;;AAlCA;EACE,8BAAA;AAqCF;;AAlCA;EACE,YAAA;AAqCF;;AAnCA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AAsCF;;AApCA;EACE,kBAAA;EACA,WAAA;EAEA,kBAAA;AAsCF;AArCE;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAuCJ;AA5BA;EAIE,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA2BF;AAlCE;EACE,WAAA;AAoCJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n.TwitterTweetCard {\n  font-family: chirp;\n  height: 100%;\n  margin-bottom: 20px;\n  flex-direction: column;\n  background-color: var(--bgColor);\n  position: relative;\n  width: 100%;\n  color: var(--mainColor);\n  // text-transform: capitalize;\n  &_Container {\n    border-radius: 3px;\n    border: 1px solid var(--borderColor);\n    &_content {\n      padding: 10px 10px 0;\n    }\n  }\n\n  &_ImageGrid {\n    width: 100%;\n    display: grid;\n    gap: 3px;\n    grid-template-columns: repeat(2, 1fr);\n    margin-bottom: 5px;\n    border-radius: 16px;\n    overflow: hidden;\n    img {\n      display: block;\n      min-height: 150px;\n      max-height: 300px;\n      height: 100%;\n      max-width: 100% !important;\n      border-radius: unset !important;\n    }\n\n    &_three_items {\n      img:first-of-type {\n        grid-row: span 2 / span 2;\n        max-height: 100%;\n      }\n    }\n    &_fullWidthImg {\n      grid-template-columns: repeat(1, 1fr) !important;\n      max-height: 100%;\n      width: 100%;\n    }\n  }\n\n\n\n  &.TweetRow {\n    min-height: auto;\n  }\n  .TwitterIconsBar {\n    display: flex;\n    align-items: center;\n    padding: 10px 0;\n    border-top: 1px solid var(--borderColor);\n    &_report {\n      padding-bottom: 55px;\n    }\n    div {\n      width: 25%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n\n  .topicTweetCard {\n    //justify-content: flex-end;\n    .tweetImageUrl {\n      max-width: 350px;\n    }\n  }\n  @include Md {\n    padding: 0;\n    border: 0;\n  }\n  @include Sm {\n    padding-inline-end: 20px;\n  }\n  a {\n    &:hover {\n      color: var(--mainColor) !important;\n      text-decoration: underline !important;\n    }\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  .sectionSeparator {\n/*     span {\n      text-transform: capitalize;\n      max-width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      color: var(--tweetSubTitleColor);\n    } */\n    .conversations {\n      display: flex;\n      justify-content: center;\n      gap: 5px;\n      align-items: center;\n      p {\n        font-size: 10px;\n        color: var(--borderColor);\n      }\n    }\n  }\n}\n\n:global(.tweetBox) {\n  .TweetBox {\n    width: 100%;\n  }\n}\n\n\n\n.socialIcon,\n.tweetSocialIcon {\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n.socialIcon,\n.tweetSocialIcon,\n.imgText a {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.infoImg {\n  section div:first-of-type {\n    margin-inline-end: 10px;\n    width: 35px !important;\n    height: 35px !important;\n    &.userImg {\n      border-radius: 100%;\n      overflow: hidden;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n\n\n.topicTweets {\n  display: flex;\n  align-items: flex-start !important;\n  padding: 0 10px;\n}\n.tweetSection {\n  justify-content: space-between;\n  font-size: 10px;\n  width: 100%;\n  @include Md {\n    justify-content: flex-start;\n    gap: 10px;\n  }\n}\n\n.spaceBetween {\n  justify-content: space-between;\n}\n\n.engRate {\n  padding-bottom: 10px;\n  margin-bottom: 10px !important;\n  font-size: 10px;\n}\n\n.engText {\n  font-weight: 700;\n}\n\n.iconText svg,\n.iconText img {\n  margin-inline-end: 5px;\n}\n\n.flagImg {\n  margin-inline-end: 10px;\n  width: 15px;\n  height: 10px;\n}\n\n.platformSection {\n  .platformName {\n    text-transform: capitalize;\n  }\n}\n\n.tweetDesc {\n  p {\n    font-size: 12px;\n    margin-bottom: 13px;\n    max-width: 100%;\n  }\n}\n\n.tweetSocialIcon {\n  justify-content: space-between;\n}\n\n.tweetSocialIcon.newStyle {\n  width: 380px;\n}\n.tweetVideo {\n  position: relative;\n  height: 130px;\n  width: 130px;\n}\n.tweetImageUrl {\n  position: relative;\n  width: 100%;\n  // margin-bottom: 10px;\n  text-align: center;\n  .VideoBtn {\n    position: absolute;\n    display: block;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--bgColor);\n    width: 37px;\n    height: 37px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--secondaryColor);\n  }\n  &.fullWidth {\n    // max-height: 350px;\n    // img {\n    //   width: auto;\n    //   max-width: 100%;\n    // }\n  }\n}\n\n.retweet {\n  svg {\n    width: 10px;\n  }\n  color: var(--mainColor);\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `TwitterTweetCard_scroll__ZSyL9`,
	"TwitterTweetCard": `TwitterTweetCard_TwitterTweetCard__e+Dwr`,
	"TwitterTweetCard_Container": `TwitterTweetCard_TwitterTweetCard_Container__yXLfo`,
	"TwitterTweetCard_Container_content": `TwitterTweetCard_TwitterTweetCard_Container_content__mTqY5`,
	"TwitterTweetCard_ImageGrid": `TwitterTweetCard_TwitterTweetCard_ImageGrid__xiwMs`,
	"TwitterTweetCard_ImageGrid_three_items": `TwitterTweetCard_TwitterTweetCard_ImageGrid_three_items__hROmO`,
	"TwitterTweetCard_ImageGrid_fullWidthImg": `TwitterTweetCard_TwitterTweetCard_ImageGrid_fullWidthImg__y6f-G`,
	"TweetRow": `TwitterTweetCard_TweetRow__fJCr0`,
	"TwitterIconsBar": `TwitterTweetCard_TwitterIconsBar__9mAW+`,
	"TwitterIconsBar_report": `TwitterTweetCard_TwitterIconsBar_report__hKN4K`,
	"topicTweetCard": `TwitterTweetCard_topicTweetCard__QXPA1`,
	"tweetImageUrl": `TwitterTweetCard_tweetImageUrl__FNfE-`,
	"sectionSeparator": `TwitterTweetCard_sectionSeparator__mYEJX`,
	"conversations": `TwitterTweetCard_conversations__YEz5-`,
	"TweetBox": `TwitterTweetCard_TweetBox__0dn3-`,
	"socialIcon": `TwitterTweetCard_socialIcon__rZkf5`,
	"tweetSocialIcon": `TwitterTweetCard_tweetSocialIcon__nollD`,
	"imgText": `TwitterTweetCard_imgText__GM3OD`,
	"infoImg": `TwitterTweetCard_infoImg__FmaY5`,
	"userImg": `TwitterTweetCard_userImg__MnkWi`,
	"topicTweets": `TwitterTweetCard_topicTweets__0I2Sg`,
	"tweetSection": `TwitterTweetCard_tweetSection__2Ld-l`,
	"spaceBetween": `TwitterTweetCard_spaceBetween__ut6L9`,
	"engRate": `TwitterTweetCard_engRate__xMyAC`,
	"engText": `TwitterTweetCard_engText__3Q9-g`,
	"iconText": `TwitterTweetCard_iconText__c07zz`,
	"flagImg": `TwitterTweetCard_flagImg__YRo4h`,
	"platformSection": `TwitterTweetCard_platformSection__d9CDs`,
	"platformName": `TwitterTweetCard_platformName__HSDur`,
	"tweetDesc": `TwitterTweetCard_tweetDesc__ViewH`,
	"newStyle": `TwitterTweetCard_newStyle__EEGZg`,
	"tweetVideo": `TwitterTweetCard_tweetVideo__v6vkL`,
	"VideoBtn": `TwitterTweetCard_VideoBtn__k6KHp`,
	"retweet": `TwitterTweetCard_retweet__s674t`
};
export default ___CSS_LOADER_EXPORT___;
